import { colorConstants } from 'config/colorConstants';

export const chart2DataParser = (data: any[], config: any) => {
    const legendsData = config.elasticityDriver?.legendMapping;
    try {
        const max = 0;
        let min = 0;
        const result = data.map((item) => {
            const legend = legendsData.find((leg: any) => leg.dataKey === item?.competitorType);
            const value = item?.bpe > 0 ? item?.bpe * -1 : item?.bpe;
            min = Math.min(value || 0, min);
            return {
                category: item?.competitorType === 'own' ? 'Own Elasticity' : item?.competitorAttributeName,
                sales: value,
                color: legend ? legend.color : colorConstants.lightGreen,
            };
        });
        return { result, min, max };
    } catch (error) {
        throw error;
    }
};
